import React from 'react';

function SettingsPage() {
  return (
    <div>
      <h2>Settings Page</h2>
      <p>Manage your application settings here.</p>
    </div>
  );
}

export default SettingsPage;
